export default "__VITE_ASSET__fdb7439b__"